module.exports = __webpack_public_path__ + "img/bg_02.1b1a7382.jpg";